import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Modal from '../../../common/modal/Modal'
import BusRetentionScheduleForm from './BusRetentionScheduleForm'
import { tzNormalizeDate } from '../../../../utils/date'
import { postBusRetentionSchedule } from '../../../../actions'

const BusRetenButton = ({
  dispatchPostBusRetentionSchedule,
  onSuccess
}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const handleSubmit = async (formValues) => {
    const { fromDateString, toDateString, location, registeredBus } = formValues
    const newFormValues = {
      fromDateString: tzNormalizeDate({ date: fromDateString }),
      toDateString: tzNormalizeDate({ date: toDateString }),
      locationId: location.value,
      registeredBusId: registeredBus.value,
    }

    handleClose();

    const created = await dispatchPostBusRetentionSchedule(newFormValues);

    if (created && onSuccess) onSuccess();
  }

  const handleClick = () => setShow(true);

  const body = show ? (
    <BusRetentionScheduleForm onSubmit={handleSubmit} onCancel={handleClose} />
  ) : null

  return (
    <>
      <Modal title='Agregar Retén' show={show} onClose={handleClose} body={body} onClickClose={handleClose} onClickCancel={handleClose} />
      <Button color="primary" onClick={handleClick}>
        <i className="fa fa-plus-circle mr-2" />
        Agregar Retén
      </Button>
    </>
  )
}

BusRetenButton.propTypes = {
  dispatchPostBusRetentionSchedule: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
}

BusRetenButton.defaultProps = {
  onSuccess: null,
}

const mapDispatchToProps = {
  dispatchPostBusRetentionSchedule: postBusRetentionSchedule
}

export default connect(null, mapDispatchToProps)(BusRetenButton);
